
<p-dialog 
    header="&nbsp;Mass Correction"
    id="mass-correction" 
    height="auto"
    [(visible)]="userService.showMassCorrection" 
    [modal]="false" 
    [maximizable]="true"
    draggable="true" 
    [closable]="true" 
    (onHide)="closeDialogbox()" 
    appendTo="body"
    [contentStyle]="{'height': 'auto','width': 'auto', 'overflow': 'auto' }"
    [style]="{'width': 'auto'}"
    styleClass="mass-correction-dialog"
    [focusOnShow]="false">
        <div class="ui-grid-col-12 nopadding container">
            @if(isDataLoading) {
                <div class="example-loading-shade">
                    <mat-spinner></mat-spinner>
                </div>
            }

            <!-- Search Criteria  -->
             @if(filterItems.length > 0) {
                <div>
                    <mat-accordion #accordion="matAccordion" [multi]="true">
                        <mat-expansion-panel [expanded]="true">
                            <mat-panel-description>
                                <div class="col-lg-12 nopadding">
                                    <mat-chip-listbox aria-label="filter" class="col-lg-12 nopadding">
                                        <span>
                                            <label for="mass-correction-filter">
                                                <em class="fa fa-filter" id="mass-correction-filter"></em>
                                            </label>
                                            @for(displayFilter of filterItems; track displayFilter.columnname + '-'+ $index; let idx = $index) { 
                                                <mat-chip id="mass-correction-{{displayFilter.columnname}}" selected 
                                                    [matTooltip]="['reportDate'].includes(displayFilter.columnname) ? (displayFilter.values[0]===displayFilter.values[1]) ? this.userService.getyyyyMMddDateFormate(displayFilter.values[0]) : (this.userService.getyyyyMMddDateFormate(displayFilter.values[0]) + ', ' + this.userService.getyyyyMMddDateFormate(displayFilter.values[1])) : displayFilter.values" 
                                                    [matTooltipShowDelay]="1000" matTooltipPosition="above">
                                                    @if(['reportDate'].includes(displayFilter.columnname)) {
                                                        <span>
                                                            {{displayFilter.label}}: {{(displayFilter.values[0]===displayFilter.values[1]) ? this.userService.getyyyyMMddDateFormate(displayFilter.values[0]) : (this.userService.getyyyyMMddDateFormate(displayFilter.values[0]) + ', ' + this.userService.getyyyyMMddDateFormate(displayFilter.values[1]))}}
                                                        </span>
                                                    }
                                                    @if(!['reportDate'].includes(displayFilter.columnname)) {
                                                        <span>
                                                            {{displayFilter.label}}: {{displayFilter.values.length>15 ? (displayFilter.values | slice:0:15) + '...' : displayFilter.values}}
                                                        </span>
                                                    }
                                                </mat-chip>
                                            }
                                        </span>
                                    </mat-chip-listbox>
                                </div>
                            </mat-panel-description>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
             }
            <div class="ui-grid-col-12">
                <!-- Display Count of Records to be updated -->
                <div class="row" class="text-center font-25 borderAlignment strong-text"><strong>Total {{totalRecords}} records will be updated</strong></div>
                <hr />
                <!-- Update Criteria -->
                <ng-container>
                    <div class="ui-g">
                        @for(massUpdatedFieldDetail of massUpdatedFieldDetails; track massUpdatedFieldDetail; let i = $index) {
                            <div class="ui-g-2 topPadding"></div>
                            <!-- Mass Correction Filter Fields -->
                            <div class="ui-g-4 topPadding">
                                <p-select id="filterFieldChoice"
                                    autofocus required="true" appendTo="body" [options]="massCorrectionFields" [style]="{'width':'100%'}" 
                                    [title]="'Update Mass Correction Fields'" placeholder="Please select value" 
                                    filter="true" required="true" [(ngModel)]="massUpdatedFieldDetails[i].filterField" (onChange)="getFilterFieldChoices(i)">
                                </p-select>
                            </div>
                            <!-- User Filter value -->
                            <div class="ui-g-4 topPadding">
                                <div>
                                    @if(optedFilterFieldDetail[i] && (optedFilterFieldDetail[i][0]?.dropdown | lowercase)=='yes' && (optedFilterFieldDetail[i][0]?.dropdowntype | lowercase)=='singleselect') {
                                        <p-select id="filterByDataTypeSingleSelect" autofocus appendTo="body" required="true" 
                                            [options]="optedFilterFieldDetail[i][0]?.dropdownvalue" [(ngModel)]="massUpdatedFieldDetails[i].filterFieldValue" 
                                            [placeholder]="'Please select value'" [style]="{'width':'100%'}">
                                        </p-select>
                                    }
                                    @if(optedFilterFieldDetail[i] && (optedFilterFieldDetail[i][0]?.datatype | lowercase)=='boolean') {
                                        <p-select id="filterbyDataTypeBoolean" autofocus required="true" appendTo="body" 
                                            [options]="optedFilterFieldDetail[i][0]?.dropdownvalue" [(ngModel)]="massUpdatedFieldDetails[i].filterFieldValue" 
                                            [placeholder]="'Please select value'" [style]="{'width':'100%'}">
                                        </p-select>
                                    }
                                    @if(!optedFilterFieldDetail[i] || (optedFilterFieldDetail && optedFilterFieldDetail[i][0]?.datatype | lowercase)=='string' && (optedFilterFieldDetail[i][0]?.dropdown | lowercase)=='no' && (optedFilterFieldDetail[i][0]?.fieldtype | lowercase)!='maskfield') {
                                        <input id="filterByDataTypeString" autofocus required="true" type="text" [ngStyle]="{'width':'100%'}" 
                                            [placeholder]="(optedFilterFieldDetail[i] && optedFilterFieldDetail[i][0]?.placeholder) ? optedFilterFieldDetail[i][0]?.placeholder : 'Please enter value'" [(ngModel)]="massUpdatedFieldDetails[i].filterFieldValue" 
                                            class="mass-input-field" />
                                    }
                                    @if(optedFilterFieldDetail[i] && (optedFilterFieldDetail[i][0]?.datatype | lowercase)=='string' && (optedFilterFieldDetail[i][0]?.dropdown | lowercase)=='no' && (optedFilterFieldDetail[i][0]?.fieldtype | lowercase)=='maskfield') {
                                        <p-inputMask [(ngModel)]="massUpdatedFieldDetails[i].filterFieldValue" [mask]="optedFilterFieldDetail[i][0]?.mask" [placeholder]="optedFilterFieldDetail[i][0]?.placeholder" [autoClear]="false" [required]="true" [ngStyle]="{'width':'100%'}" 
                                        class="mass-input-mask-field"></p-inputMask>
                                    }
                                    @if(optedFilterFieldDetail[i] && (optedFilterFieldDetail[i][0]?.datatype | lowercase)=='int') {
                                        <p-inputNumber class="mass-inputnumber-field" [ngStyle]="{'width':'100%'}" [(ngModel)]="massUpdatedFieldDetails[i].filterFieldValue" mode="decimal" [useGrouping]="false" [maxFractionDigits]="0" placeholder="Please enter integer" [allowEmpty]="true" />
                                    }
                                    @if(optedFilterFieldDetail[i] && (optedFilterFieldDetail[i][0]?.datatype | lowercase)=='float') {
                                        <p-inputNumber class="mass-inputnumber-field" [ngStyle]="{'width':'100%'}" [(ngModel)]="massUpdatedFieldDetails[i].filterFieldValue" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5" placeholder="Please enter float" [allowEmpty]="true" />
                                    }
                                </div>
                            </div>
                            <div class="ui-g-2 topPadding">
                                <!-- Mandatory Comment Field (E.g. - Status) -->
                                @if(optedFilterFieldDetail[i] && optedFilterFieldDetail[i][0]?.isMandatoryComment) {
                                    <textarea id="filterByMandatoryCommentField" autofocus rows="2" cols="10" pTextarea required="true" type="text" [ngStyle]="{'width':'100%'}" 
                                        [placeholder]="'Please enter comment'" [(ngModel)]="massUpdatedFieldDetails[i].filterFieldMandatoryComment" 
                                        class="mass-input-field"></textarea>
                                }

                                <!-- Providing Remove Button except First Mass Update Field Row -->
                                @if(i > 0) {
                                    <button type="button" id="remove-mass-correction-row" class="btn btn-primary footer-buttons" pButton icon="pi pi-minus" (click)="removeDialogboxRow(i)"></button>
                                }
                            </div>
                        }
                    </div>
                    <div class="ui-g">
                        <div class="ui-g-12 topPadding text-right">
                            <button type="button" id="add-mass-correction-row" class="btn btn-primary footer-buttons" pButton icon="pi pi-plus" (click)="addDialogboxRow()" label="Add Filter"></button>
                        </div>
                    </div>
                </ng-container>
                <hr />
            </div>
        </div>

    <ng-template #footer>
        <button type="button" id="mass-correction-close" class="btn btn-primary footer-buttons" pButton icon="pi pi-close" (click)="closeDialogbox()" label="Close"></button>
        <button type="button" id="mass-correction-update" class="btn btn-primary footer-buttons" pButton icon="pi pi-close" [disabled]="isClickedOnce" (click)="updateDialogbox()" label="Update"></button>
    </ng-template>

</p-dialog>

<!-- Mass Correction component Confirmation Dialog -->
<p-confirmDialog
  id="mass-correction-confirmation"  
  key="informationDialogue"
  appendTo="body" 
  header="Information" 
  icon="pi pi-exclamation-triangle" 
  styleClass="mass-correction-confirmation-dialog">
</p-confirmDialog>

@if(showMessage){
<p-dialog id="showMessageMassCorrection" [modal]="true" header="Information" 
styleClass="quick-view-grid-row filterbox filter-dialog-box" [(visible)]="showMessage"
[closable]="true" appendTo="body" (onHide)="showMessage=false"  
(visibleChange)="showMessage=false">
    <span class="showMessage">{{showMessageDetails}}</span>
    <ng-template #footer>
            <p-button id="info-button" class="applyButton floatRight" icon="fa fa-check" (onClick)="showMessage=false" label="Ok"></p-button>
   </ng-template>
</p-dialog>
}